import React from "react";

type TableRowProps = {
    onClick?: () => void;
    onMouseEnter?: () => void;
    columns: JSX.Element[];
    className?: string;
};

export function TableRow(props: TableRowProps) {
    return <tr
        className={props.className}
        onClick={props.onClick}
        onMouseEnter={props.onMouseEnter}
    >
        {props.columns.map((column) => {
            return column
        })}
    </tr>;
}
